import(/* webpackMode: "eager" */ "/app/client/src/app/[[...slug]]/page.tsx");
